import { render, staticRenderFns } from "./MatchChart.vue?vue&type=template&id=5d9826f6&scoped=true"
import script from "./MatchChart.vue?vue&type=script&lang=js"
export * from "./MatchChart.vue?vue&type=script&lang=js"
import style0 from "./MatchChart.vue?vue&type=style&index=0&id=5d9826f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9826f6",
  null
  
)

export default component.exports